interface FlameCardProps {
  imageUrl: string;
  displayName: string;
  onLoad?: () => void;
}

export function FlameCard({ imageUrl, displayName, onLoad }: FlameCardProps) {
  return (
    <div className="relative w-[277px] h-[277px] mx-auto">
      <img
        src={imageUrl}
        alt={`${displayName}'s flame`}
        className="w-full h-full rounded-full object-cover"
        onLoad={onLoad}
      />
    </div>
  );
}
